import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const MaskedLine = ({ children, delay = 0, onLoad = false, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-8% 0px" });
  const show = onLoad || inView;
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
      <motion.span
        className={`block will-change-transform ${className}`}
        initial={{ y: "110%" }}
        animate={show ? { y: "0%" } : { y: "110%" }}
        transition={{ duration: 1.2, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
